import "./ArtOfExotic.scss";
import { motion } from "framer-motion";
import { Autoplay, FreeMode } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { baseUrl } from "../../../utils/apiData";

const ArtOfExotic = ({ title, para, dataList }) => {
  return (
    <section className="art_of_exotic p_t p_b">
      <div className="content_wrap">
        <div className="sec_title">
          <h2 className="gold">
            {title &&
              title
                ?.split("")
                .map((char, k) => (
                  <motion.span
                    initial={{ translateX: 24, opacity: 0 }}
                    whileInView={{ translateX: 0, opacity: 1 }}
                    transition={{
                      duration: 0.4,
                      ease: "easeInOut",
                      delay: 0.02 * k,
                    }}
                    key={k}
                  >
                    {char}
                  </motion.span>
                ))
                .concat("")}
          </h2>
          {para && <p className="gold">{para}</p>}
        </div>
      </div>

      {dataList?.length > 0 && (
        <Swiper
          loop={true}
          spaceBetween={24}
          slidesPerView={4}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          speed={3000}
          freeMode={true}
          modules={[Autoplay, FreeMode]}
          breakpoints={{
            1400: {
              slidesPerView: 4,
            },
            900: {
              slidesPerView: 3,
            },
            600: {
              slidesPerView: 2,
            },
            10: {
              slidesPerView: 1,
            },
          }}
        >
          {[...dataList, ...dataList]?.map((img, l) => {
            return (
              <SwiperSlide key={l}>
                <div className="insta_card">
                  <div className="img_wrap">
                    <img src={`${baseUrl}/${img}`} alt="Award" />
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
    </section>
  );
};

export default ArtOfExotic;
